import React from "react";

export default function EditAddContactPage() {
  return <div>adminlis</div>;
}
